import axios from 'axios';
import { trackRequestStart, trackRequestEnd } from '../loading/globalLoading';

const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_API_BASE_URL ||
  'http://localhost:3001';

// TODO: remover — delay só pra testar o GlobalLoading em local
const DEV_LOADING_DELAY_MS = process.env.NODE_ENV === 'development' ? 1000 : 0;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const apiClient = axios.create({
  baseURL,
});

export const setAuthToken = (token) => {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
};

apiClient.interceptors.request.use(
  (config) => trackRequestStart(config),
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  async (response) => {
    if (DEV_LOADING_DELAY_MS && !response.config?.skipGlobalLoading) {
      await delay(DEV_LOADING_DELAY_MS);
    }
    trackRequestEnd(response.config);
    return response;
  },
  async (error) => {
    if (DEV_LOADING_DELAY_MS && !error.config?.skipGlobalLoading) {
      await delay(DEV_LOADING_DELAY_MS);
    }
    trackRequestEnd(error.config || {});
    return Promise.reject(error);
  }
);

export default apiClient;
